<template>
  <div class="container">
    <el-upload
      class="upload-demo"
      action
      :on-remove="handleRemove"
      multiple
      :show-file-list="isShowList"
      :file-list="loadFileList"
      :before-upload="beforeUpload"
      :http-request="upload"
    >
      <el-button type="primary" icon="jr-iconjr-icon-upload"
        >数据上传</el-button
      >
    </el-upload>
    <p class="download-link">
      <span>请按指定模板上传，</span>
      <a class="download-btn" :href="templateUrl">下载模板</a>
    </p>
  </div>
</template>
<script>
import { uploadImportCompany } from "../api/common";
export default {
  props: {
    loadFileList: {
      type: Array,
    },
    isShowList: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fileArray: [],
      templateUrl:
        "https://elitego-data-1300257084.cos.ap-shanghai.myqcloud.com/elite-all/2025.07.23%E4%BA%BA%E6%89%8D%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx",
    };
  },
  computed: {
    Authorization() {
      return sessionStorage.getItem("token");
    },
  },
  methods: {
    handleRemove(file, fileList) {
      // this.$emit('removeFile', file)
    },

    async upload(file) {
      const form = new FormData();
      this.fileArray.push(file.file);
      this.$emit("filesDo", this.fileArray);
    },

    beforeUpload(file) {
      // let FileExt = file.name.replace(/.+\./, '')
      // let flag = ['doc', 'docx', 'xls', 'xlsx'].includes(FileExt)
      // const isLt5M = file.size / 1024 / 1024 < 5
      // if (!flag) this.$message.error('文件格式错误请重新上传!')
      // if (!isLt5M) this.$message.error('上传的文件大小不能超过5MB!')
      // return flag && isLt5M
    },
  },
};
</script>
<style lang="less" scoped>
.iconjr-icon-link {
  font-size: 12px;
}
.the-active {
  .el-button {
    color: #4da75b !important;
  }
  i {
    color: #4da75b !important;
  }
}
.container {
  display: flex;
  align-items: center;
}
.download-link {
  display: flex;
  justify-content: center;
  margin-left: 20px;
}

.download-btn {
  color: #1e9fff;
  cursor: pointer;
}

a {
  color: #1e9fff;
}
</style>
